import React, { Fragment } from "react";
import WidgetsWrapper from "./WidgetsWrapper/WidgetsWrapper";
import GreetingCard from "./GreetingCard/GreetingCard";
import styles from "./dashboard.module.scss";
// import Breadcrumbs from "../Shared/Breadcrumbs";

const Dashboard = () => {
  return (
    <Fragment>
      {/* <Breadcrumbs
        mainPageTitle={"Dashboard"}
        path={"/dashboard"}
        subPageTitle={"Default"}
      /> */}
      <div className={styles["dashboard_container"]}>
        <div>
          <GreetingCard />
        </div>
        <div className={styles["widgets_wrapper"]}>
          <WidgetsWrapper />
        </div>
      </div>
    </Fragment>
  );
};

export default Dashboard;
